import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const setToken = (t) => {
  localStorage.setItem("idcore_token", t);
  document.cookie = `access_token=${t}; path=/; max-age=604800; SameSite=Lax; Secure`;
};

export const clearToken = () => {
  localStorage.removeItem("idcore_token");
  document.cookie = "access_token=; path=/; max-age=0; SameSite=Lax; Secure";
};

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("idcore_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && window.location.pathname !== "/login") {
      clearToken();
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Une erreur est survenue.";
};
